import React from 'react';
import { actionType } from 'utils/constants';

import utils from 'utils';

import CommonButton from 'components/Buttons/CommonButton';
import { useDispatch, useSelector } from 'react-redux';
import selectors from 'state/selectors';
import actions from 'state/actions';

const EditTemplate = () => {
  const t = utils.intl.useTranslator();

  const dispatch = useDispatch();

  const selectedRow = useSelector(selectors.configurator.getSelectedAP2row);
  const isEdit = useSelector(selectors.configurator.getIsEditAP2Template);
  const editRowID = useSelector(selectors.configurator.getEditedRowAP2ID);
  const { row: selectedNOPORow } = useSelector(selectors.modal.getModalProps);

  const editRow = async () => {
    if (selectedRow && selectedRow.id !== undefined) {
      dispatch(actions.configurator.setEditedRowAP2ID(selectedRow.id));
      dispatch(actions.configurator.setIsEditAP2Template(true));
    }
  };

  return (
    <CommonButton
      id="edit-template"
      action={() => editRow()}
      scope="tertiary"
      value={t('edit')}
      customIcon="pen"
      disabled={
        isEdit ||
        editRowID !== null ||
        selectedRow === null ||
        !utils.user.isActionByCompanyActive(actionType.EDIT_AP2_TEMPLATE, selectedNOPORow.companyName)
      }
    />
  );
};

export default EditTemplate;
